import React from 'react'
import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogTitle from '@material-ui/core/DialogTitle'
import DialogContent from '@material-ui/core/DialogContent'
import DialogContentText from '@material-ui/core/DialogContentText'
import IconButton from '@material-ui/core/IconButton'
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableRow from '@material-ui/core/TableRow'
import TableHead from '@material-ui/core/TableHead'
import TableContainer from '@material-ui/core/TableContainer'
import Paper from '@material-ui/core/Paper'
import { makeStyles } from '@material-ui/core/styles'
import { withStyles } from '@material-ui/core/styles'
import { green } from '@material-ui/core/colors'
import CheckCircleIcon from '@material-ui/icons/CheckCircle'
import CancelIcon from '@material-ui/icons/Cancel'
import { Typography } from '@material-ui/core'
import { red } from '@material-ui/core/colors'
import ImportExportIcon from '@material-ui/icons/ImportExport'
import authService from '../api-authorization/AuthorizeService'
import { LinearProgress, CircularProgress } from '@material-ui/core'
import Alert from '@material-ui/lab/Alert'
import CloseIcon from '@material-ui/icons/Close'
import Tooltip from '@material-ui/core/Tooltip'
import Papa from 'papaparse'

export default function ShipmentImportDialog(props) {
    const [open, setOpen] = React.useState(false)
    const [isLoading, setIsLoading] = React.useState(false)
    const [isSuccess, setIsSuccess] = React.useState(false)
    const [isError, setIsError] = React.useState(false)
    const [errorMessage, setErrorMessage] = React.useState('')
    const [selectedFile, setSelectedFile] = React.useState(null)
    const [isSelected, setIsSelected] = React.useState(false)
    const [parsedData, setParsedData] = React.useState([])
    const [importProfile, setImportProfile] = React.useState(null)

    const handleClickOpen = () => {
        // clear any previous data
        setIsSelected(false)
        setSelectedFile(null)

        // get shipment import profile for org
        fetch('api/shipments/GetShipmentImportProfile', {
            method: 'GET'
        })
            .then(response => response.json())
            .then(result => {
                setImportProfile(result)
            })
            .catch(error => {
                console.error('Error:', error)
            })

        setOpen(true)
    }

    const handleClose = () => {
        if (selectedFile !== null || parsedData.length > 0) {
            if (window.confirm('Are you sure you want to cancel the import?')) {
                setIsSelected(false)
                setSelectedFile(null)
                setParsedData([])
                setOpen(false)
            }
        } else {
            setOpen(false)
        }
    }

    const handleSuccess = () => {
        setIsSuccess(true)
        // reload page
        // setInterval(function () {
        //     setIsSuccess(false)
        //     setOpen(false)
        // }, 4000)
        // window.location.reload()
    }

    const handleError = errorMessage => {
        setErrorMessage(errorMessage)
        setIsError(true)
    }

    const handleFormReset = () => {
        setIsSelected(false)
        setSelectedFile(null)
        setParsedData([])
    }

    const handleSelectedFileChange = event => {
        if (event.target.files.length === 0) {
            return
        }
        setSelectedFile(event.target.files[0])
        // parse the file
        const reader = new FileReader()
        reader.onload = e => {
            const text = e.target.result
            let result = Papa.parse(text, { header: true })

            // need to add a flag to each row to track import status
            result.data.forEach(row => {
                row.importing = false
                row.imported = false
                row.importError = false
            })

            // there may be rows which are duplicates but have different container numbers and container types, these need to be merged into a single array property
            // so that the import process can handle them correctly
            let mergedData = []

            // first add empty importContainers array to each row



            result.data.forEach(row => {
                let existingRow = mergedData.find(r => r.houseBillNumber === row.houseBillNumber)
                if (existingRow) {
                    // merge the container numbers and types
                    if (!existingRow.importContainers) {
                        existingRow.importContainers = []
                    }
                    existingRow.importContainers.push(
                        {
                            containerNumber: row.containerNumber,
                            containerType: row.containerType
                        }
                    )
                } else {
                    row.ImportContainers = [
                        {
                            containerNumber: row.containerNumber,
                            containerType: row.containerType
                        }
                    ]
                    mergedData.push(row)
                }
            })

            setParsedData(mergedData)
            setImportProfile(
                { ...importProfile, data: result.data }
            )
        }
        reader.readAsText(event.target.files[0])
        setIsSelected(true)
    }

    const useStyles = makeStyles(theme => ({
        root: {
            display: 'flex',
            alignItems: 'center'
        },
        wrapper: {
            margin: theme.spacing(1),
            position: 'relative'
        },
        buttonSuccess: {
            backgroundColor: green[500],
            '&:hover': {
                backgroundColor: green[700]
            }
        },
        fabProgress: {
            color: green[500],
            position: 'absolute',
            top: -6,
            left: -6,
            zIndex: 1
        },
        buttonProgress: {
            color: green[500],
            position: 'absolute',
            top: '50%',
            left: '50%',
            marginTop: -12,
            marginLeft: -12
        }
    }))
    const classes = useStyles()

    const generateTemplate = () => {
        // generate a csv file with the headers
        const csvData = {
            data: [],
            fields: importProfile.fields.map(field => field.name)
        }
        const csv = Papa.unparse(csvData)
        const blob = new Blob([csv], { type: 'text/csv' })
        const url = window.URL.createObjectURL(blob)
        const a = document.createElement('a')
        a.setAttribute('hidden', '')
        a.setAttribute('href', url)
        a.setAttribute('download', 'ShipmentImportTemplate.csv')
        document.body.appendChild(a)
        a.click()
        window.URL.revokeObjectURL(url)
        a.remove()
    }      

    const mapRowData = (rows, fields) => {
        return rows.map(row => {
            let newRow = {}
            fields.forEach(field => {
                newRow[field.value] = row[field.name]
            })
            newRow['importResult'] = ''
            newRow['importResultMessage'] = ''
            newRow['importedShipmentNumber'] = ''
            newRow['importLog'] = ''
            return newRow
        })
    }

    const handleImportShipments = async (specificRow = null, rowIndex = null) => {

        let importShipments = []
        if (rowIndex) {
            importShipments.push(specificRow)
        } else {
            importShipments = parsedData
        }

        if (importShipments.length === 0) {
            setIsError(true)
            setErrorMessage('No shipment data to import.')
        } else {
            importShipments = mapRowData(importShipments, importProfile.fields)
        }

        // need to check if any required fields are missing and show an error
        let missingFields = []
        importShipments.forEach(row => {
            importProfile.fields.forEach(field => {
                if (field.required && row[field.value] === '') {
                    // if field doesn't already exist then add
                    if (!missingFields.includes(field.name)) {
                        missingFields.push(field.name)
                    }
                }
            })
        })

        if (missingFields.length > 0) {
            setIsError(true)
            setErrorMessage('The following required fields are missing: ' + missingFields.join(', '))
            return
        }

        if (importShipments.length === 0) {
            setIsError(true)
            setErrorMessage('No shipment data to import.')
        } else {
            setIsError(false)
            setIsSuccess(false)
            setErrorMessage('')

            // if it's a specific row then set the importing flag in parsedData, otherwise set all
            if (rowIndex) {
                setParsedData(parsedData.map((row, index) => {
                    if (index === rowIndex) {
                        row.importing = true
                    }
                    return row
                }))
            } else {
                setParsedData(parsedData.map(row => {
                    row.importing = true
                    return row
                }))
            }

            const token = await authService.getAccessToken()
            const header = {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json'
            }
            const jsonPayload = JSON.stringify(importShipments)

            try {

                const importResponse= await fetch('api/shipments/ImportShipments', {
                    headers: header,
                    method: 'POST',
                    body: jsonPayload
                })

                if (importResponse.ok) {
                    const importResult = await importResponse.json()

                    // result is an array of import results with ImportResult, ImportResultMessage and ImportedShipmentNumber
                    importResult.forEach((result, resultIndex) => {
                        if (rowIndex) {
                            setParsedData(parsedData.map((row, index) => {
                                if (index === rowIndex) {
                                    row.imported = result.importResult === 'Success'
                                    row.importError = result.importResult === 'Failed'
                                    row.importResult = result.importResult
                                    row.importResultMessage = result.importResultMessage
                                    row.importLog = result.importLog
                                    row.importedShipmentNumber = result.importedShipmentNumber
                                }
                                return row
                            }))
                        } else {
                            setParsedData(parsedData.map((row, index) => {
                                if (index === resultIndex) {
                                    row.imported = result.importResult === 'Success'
                                    row.importError = result.importResult === 'Failed'
                                    row.importResult = result.importResult
                                    row.importResultMessage = result.importResultMessage
                                    row.importLog = result.importLog
                                    row.importedShipmentNumber = result.importedShipmentNumber
                                }
                                return row
                            }))
                        }
                    })
                    handleSuccess()
                } else {
                    const error = await importResponse.text()
                    setIsError(true)
                    setErrorMessage('An error occurred while importing shipments: ' + error)
                }
            }
            catch (error) {
                console.error('Error:', error)
                setIsError(true)
                setErrorMessage('An error occurred while importing shipments.')
            } finally {
                setIsLoading(false)
                if (rowIndex) {
                    setParsedData(parsedData.map((row, index) => {
                        if (index === rowIndex) {
                            row.importing = false
                        }
                        return row
                    }))
                } else {
                    setParsedData(parsedData.map(row => {
                        row.importing = false
                        return row
                    }))
                }
            }
        }
    }

    return (
        <>
            <Tooltip title="Import Shipments" aria-label="import shipments">
                <IconButton
                    onClick={handleClickOpen}
                >
                    <ImportExportIcon />
                    Import Shipments
                </IconButton>
            </Tooltip>
            <Dialog open={open} onClose={handleClose} fullWidth={true}>
                <DialogTitle>Shipments Import</DialogTitle>
                <DialogContent dividers={true}>
                    {
                        // user needs to be able to download a template
                        importProfile !== null && (
                            <Button
                                variant="contained"
                                color="primary"
                                size="small"
                                onClick={generateTemplate}
                                >
                                Download Template
                            </Button>
                        )
                    }
                </DialogContent>
                <DialogContent dividers={true}>
                    <TableContainer component={Paper} style={{ minHeight: '400px' }}>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    {
                                        // import profile has headers defined
                                        importProfile !== null &&
                                            importProfile.fields.map(
                                                (field, index) => (
                                                    // if it's the first field then add a cell for row actions
                                                    index === 0 ?
                                                    (
                                                        <>
                                                            <TableCell key={index}>
                                                                <Typography>Actions</Typography>
                                                            </TableCell>
                                                            <TableCell key={`${index}-2`}>
                                                                <Typography>Result</Typography>
                                                            </TableCell>
                                                            <TableCell key={`${index}-3`}>
                                                                <Typography>Log</Typography>
                                                            </TableCell>
                                                        </>
                                                    ) :
                                                    (
                                                        <TableCell key={index}>
                                                            { 
                                                                // if header is required then show it in red
                                                                field.required ?
                                                                <Typography style={{
                                                                    color: red[500],
                                                                    fontWeight: 'bold'
                                                                }}>{field.name + '*'}</Typography> :
                                                                <Typography>{field.name}</Typography>
                                                            }                                                   
                                                        </TableCell>
                                                    )
                                                    
                                                )
                                            )
                                    }
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {parsedData.map((row, rowIndex) => (
                                    // if it's the first row then 
                                    <TableRow key={rowIndex}>
                                        {importProfile !== null &&
                                            importProfile.fields.map(
                                                (field, fieldIndex) => (
                                                    // add actions if first field
                                                    fieldIndex === 0 ?
                                                    (
                                                        <>
                                                            <TableCell key={fieldIndex}>
                                                                {
                                                                    row.importing ?
                                                                    <CircularProgress /> :
                                                                    row.imported ?
                                                                    <CheckCircleIcon style={{ color: green[500] }} /> :
                                                                    row.importError ?
                                                                    <CancelIcon style={{ color: red[500] }} /> :
                                                                    <Button
                                                                        id={'import-' + rowIndex}
                                                                        variant='contained'
                                                                        color="primary"
                                                                        size="small"
                                                                        disabled={isLoading}
                                                                        className={classes.button}
                                                                        onClick={() => handleImportShipments(row, rowIndex)}
                                                                    >
                                                                        Import 
                                                                    </Button>
                                                                }
                                                            </TableCell>
                                                            <TableCell key={`${fieldIndex}-2`}>
                                                                {row.importResultMessage}
                                                            </TableCell>
                                                            <TableCell key={`${fieldIndex}-3`}>
                                                                <Button
                                                                    id={'import-' + rowIndex}
                                                                    variant='text'
                                                                    color="primary"
                                                                    size="small"
                                                                    disabled={isLoading}
                                                                    className={classes.button}
                                                                    onClick={() => alert(row.importLog || 'No log available.')}
                                                                >
                                                                    Log    
                                                                </Button>
                                                            </TableCell>
                                                        </>

                                                    ) :
                                                    (
                                                        // otherwise add the data
                                                        // if the field is not in the row then show empty cell
                                                        row[field.name] === undefined ?
                                                        <TableCell key={fieldIndex}></TableCell> :
                                                        // otherwise show the data
                                                        (
                                                            // if the field is required and empty then show it in red
                                                            field.required && row[field.name] === '' ?
                                                            <TableCell key={fieldIndex} style={{backgroundColor: red[500]}}>
                                                                {row[field.name]}
                                                            </TableCell> :
                                                            // otherwise show it normally
                                                            <TableCell key={fieldIndex}>
                                                                {row[field.name]}
                                                            </TableCell>
                                                        )
                                                    )
                                                )
                                            )
                                        }
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </DialogContent>
                <DialogContent dividers={true}>
                <input type="file" name="file" onChange={handleSelectedFileChange} accept='.csv' />
                    {isSelected ? (
                        <div>
                            <p>Filename: {selectedFile?.name}</p>
                            <p>Type: {selectedFile?.type}</p>
                            <p>
                                Size:{' '}
                                {parseInt(Number(selectedFile?.size) / 1000)}kb
                            </p>
                            <p>
                                Last Modified:{' '}
                                {selectedFile?.lastModifiedDate.toLocaleDateString()}
                            </p>
                        </div>
                    ) : (
                        <p>Select a file to show details</p>
                    )}
                </DialogContent>
                {isLoading && <LinearProgress />}
                <DialogActions>
                    <Button onClick={handleClose} color="primary" disabled={isLoading}>
                        Cancel
                    </Button>
                    <Button onClick={handleFormReset} color="primary" disabled={isLoading}>
                        Reset
                    </Button>
                    <Button variant="contained"onClick={handleImportShipments} color="primary" disabled={isLoading}>
                        Import All
                    </Button>
                </DialogActions>
                {isSuccess && (
                    <Alert severity="info">
                        {
                            parsedData.filter(row => row.imported).length + ' shipments imported successfully.'
                        }
                    </Alert>
                )}
                {isError && (
                    <Alert
                        severity="error"
                        action={
                            <IconButton
                                aria-label="close"
                                color="inherit"
                                size="small"
                                onClick={() => {
                                    setIsError(false)
                                }}
                            >
                                <CloseIcon fontSize="inherit" />
                            </IconButton>
                        }
                    >
                        {errorMessage}
                    </Alert>
                )}
            </Dialog>
        </>
    )
}
